export default "__VITE_ASSET__vAi8DA_g__"